import { render } from "./Betreuer.vue?vue&type=template&id=a48f124a&scoped=true"
import script from "./Betreuer.vue?vue&type=script&lang=js"
export * from "./Betreuer.vue?vue&type=script&lang=js"

import "./Betreuer.vue?vue&type=style&index=0&id=a48f124a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48f124a"]])

export default __exports__